(() => {
  const els = document.querySelectorAll('.wsp [data-reveal], .wsp [data-reveal-group]');
  if (!els.length) return;
  if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(el => el.classList.add('is-in'));
    return;
  }
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  els.forEach(el => io.observe(el));
  // Theme editor: re-run when a section is re-rendered
  document.addEventListener('shopify:section:load', e => {
    e.target.querySelectorAll('[data-reveal], [data-reveal-group]').forEach(el => el.classList.add('is-in'));
  });
})();

// Header: sticky state, dropdowns, mobile drawer
(() => {
  const header = document.querySelector('[data-wsp-header]');
  if (!header) return;
  const onScroll = () => header.classList.toggle('is-stuck', window.scrollY > 8);
  onScroll(); window.addEventListener('scroll', onScroll, { passive: true });

  const items = [...header.querySelectorAll('[data-wsp-menu]')];
  let timer;
  const close = except => items.forEach(i => { if (i !== except) { i.classList.remove('is-open'); i.querySelector('button').setAttribute('aria-expanded', 'false'); } });
  const open = i => { close(i); i.classList.add('is-open'); i.querySelector('button').setAttribute('aria-expanded', 'true'); };
  items.forEach(i => {
    const btn = i.querySelector('button');
    btn.addEventListener('click', () => i.classList.contains('is-open') ? close() : open(i));
    i.addEventListener('mouseenter', () => { if (matchMedia('(hover: hover)').matches) { clearTimeout(timer); open(i); } });
    i.addEventListener('mouseleave', () => { if (matchMedia('(hover: hover)').matches) timer = setTimeout(() => close(), 160); });
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { const o = items.find(i => i.classList.contains('is-open')); close(); o && o.querySelector('button').focus(); } });
  document.addEventListener('click', e => { if (!header.contains(e.target)) close(); });

  const burger = header.querySelector('[data-wsp-burger]');
  const drawer = header.querySelector('#wsp-drawer');
  burger && burger.addEventListener('click', () => {
    const on = drawer.hidden;
    drawer.hidden = !on; header.classList.toggle('is-drawer', on);
    burger.setAttribute('aria-expanded', String(on)); burger.setAttribute('aria-label', on ? 'Close menu' : 'Open menu');
    document.documentElement.style.overflow = on ? 'hidden' : '';
  });
})();

// Click-to-load YouTube (privacy-enhanced; nothing loads from YouTube until play)
document.addEventListener('click', e => {
  const b = e.target.closest('[data-wsp-yt]');
  if (!b) return;
  const f = document.createElement('iframe');
  f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(b.dataset.wspYt) + '?autoplay=1&rel=0';
  f.title = b.getAttribute('aria-label') || 'Video';
  f.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen';
  f.allowFullscreen = true;
  b.replaceWith(f);
});
